import React, { useState, useEffect } from "react";

// Add this CSS at the top of your component
const styles = {
    productGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '20px',
        padding: '20px'
    },
    productCard: {
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '15px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    productImage: {
        width: '150px',
        height: '150px',
        objectFit: 'contain',
        marginBottom: '10px'
    },
    productTitle: {
        fontSize: '14px',
        fontWeight: 'bold',
        textAlign: 'center',
        margin: '10px 0',
        height: '40px',
        overflow: 'hidden'
    },
    variantList: {
        listStyle: 'none',
        padding: '0',
        margin: '0',
        fontSize: '13px',
        width: '100%'
    },
    variantItem: {
        padding: '4px 0',
        borderBottom: '1px solid #eee',
        display: 'flex',
        justifyContent: 'space-between'
    },
    totalStock: {
        fontWeight: 'bold',
        marginTop: '10px',
        padding: '8px',
        backgroundColor: '#f5f5f5',
        borderRadius: '4px',
        width: '100%',
        textAlign: 'center'
    }
};

const CollectionsStats = () => {
    const [collections, setCollections] = useState([]);
    const [selectedCollection, setSelectedCollection] = useState("");
    const [products, setProducts] = useState([]);
    const [productStock, setProductStock] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Fetch collections for dropdown
        const fetchCollections = async () => {
            try {
                const response = await fetch("https://bymolive-backend-995926394015.us-central1.run.app/api/get-collections");
                const data = await response.json();
                setCollections(data.collections || []);
            } catch (error) {
                console.error("Error fetching collections:", error);
            }
        };

        fetchCollections();
    }, []);

    const handleCollectionChange = async (e) => {
        const collectionId = e.target.value;
        setSelectedCollection(collectionId);
        setProductStock({}); // Clear stock data when switching collections

        if (collectionId) {
            setLoading(true);
            try {
                const response = await fetch(`https://bymolive-backend-995926394015.us-central1.run.app/api/get-collection-products?collection_id=${collectionId}`);
                const data = await response.json();
                setProducts(data.products || []);
                setLoading(false);

                if (data.products && data.products.length > 0) {
                    fetchStockInBatches(data.products);
                }
            } catch (error) {
                setLoading(false);
                console.error("Error fetching products:", error);
            }
        }
    };

    const fetchStockInBatches = async (products) => {
        const batchSize = 5; // Process 5 products at a time
        const timeout = 4000; // 2-second delay between batches

        for (let i = 0; i < products.length; i += batchSize) {
            const batch = products.slice(i, i + batchSize);
            const requests = batch.map((product) =>
                fetch(`https://bymolive-backend-995926394015.us-central1.run.app/api/get-product-stock?product_id=${product.id}`)
                    .then((response) => response.json())
                    .then((data) => {
                        console.log("Fetched stock for product:", data);
                        return {
                            id: product.id,
                            stock: data.total_stock || 0,
                            variants: data.variants || [],
                        };
                    })
                    .catch((error) => {
                        console.error(`Error fetching stock for product ID ${product.id}:`, error);
                        return { id: product.id, stock: 0, variants: [] };
                    })
            );

            const results = await Promise.all(requests);

            // Update the stock data for the fetched batch
            setProductStock((prev) => {
                const updatedStock = { ...prev };
                results.forEach((result) => {
                    updatedStock[result.id] = {
                        total_stock: result.stock,
                        variants: result.variants,
                    };
                });
                return updatedStock;
            });

            // Wait for the timeout before fetching the next batch
            await new Promise((resolve) => setTimeout(resolve, timeout));
        }
    };

    return (
        <div>
            <h1>Shopify Collection Viewer</h1>
            <select 
                onChange={handleCollectionChange} 
                value={selectedCollection}
                style={{ marginBottom: '20px', padding: '8px', width: '200px' }}
            >
                <option value="">Select a Collection</option>
                {collections.map((collection) => (
                    <option key={collection.id} value={collection.id}>
                        {collection.title}
                    </option>
                ))}
            </select>

            {loading && <p>Loading products...</p>}

            <div style={styles.productGrid}>
                {products.map((product) => (
                    <div key={product.id} style={styles.productCard}>
                        <img 
                            src={product.first_image} 
                            alt={product.title} 
                            style={styles.productImage}
                        />
                        <div style={styles.productTitle}>
                            {product.title}
                        </div>
                        
                        <div style={styles.totalStock}>
                            Total Stock: {
                                productStock[product.id]?.total_stock !== undefined
                                    ? productStock[product.id].total_stock
                                    : "Loading..."
                            }
                        </div>

                        {productStock[product.id]?.variants.length > 0 && (
                            <ul style={styles.variantList}>
                                {productStock[product.id].variants.map((variant) => (
                                    <li key={variant.id} style={styles.variantItem}>
                                        <span>{variant.title}</span>
                                        <span>{variant.inventory_quantity}</span>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CollectionsStats;
